var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.172 15.3334L16.772 0.933371C16.196 0.357371 15.396 0.00537109 14.516 0.00537109H3.31603C1.55603 0.00537109 0.116028 1.44537 0.116028 3.20537V14.4054C0.116028 15.2854 0.468028 16.0854 1.06003 16.6774L15.46 31.0774C16.036 31.6534 16.836 32.0054 17.716 32.0054C18.596 32.0054 19.396 31.6534 19.972 31.0614L31.172 19.8614C31.764 19.2854 32.116 18.4854 32.116 17.6054C32.116 16.7254 31.748 15.9094 31.172 15.3334ZM5.71603 8.00537C4.38803 8.00537 3.31603 6.93337 3.31603 5.60537C3.31603 4.27737 4.38803 3.20537 5.71603 3.20537C7.04403 3.20537 8.11603 4.27737 8.11603 5.60537C8.11603 6.93337 7.04403 8.00537 5.71603 8.00537Z",
    fill: "#65707B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinTag);
export default ForwardRef;